import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SessionService } from 'src/app/services/session.service';

@Injectable({
  providedIn: 'root'
})
export class AwsPurchaseOrderSupplierService {

  constructor(
    private http: HttpClient, 
    private sessionService: SessionService
  ) { }

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'client-id':'apliclientesksks',
      'client-hash':'apliclientesksks',
      'Auth': this.sessionService.token
    })
  };

  private httpOptionsNew = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.sessionService.token}`
    })
  };

  detailSupplierPurchaseOrder(body){
    return this.http.post(`${environment.baseUrlAPI}/company/purchaseOrder/supplier/detail`, body , this.httpOptions);
  }

  acceptedSupplierPurchaseOrder(body){
    return this.http.post(`${environment.baseUrlAPI}/company/purchaseOrder/supplier/accepted`, body , this.httpOptions);
  }

  rejectedSupplierPurchaseOrder(body){
    return this.http.post(`${environment.baseUrlAPI}/company/purchaseOrder/supplier/rejected`, body , this.httpOptions);
  }
  
  //PANEL
  dependencySupplierPurchaseOrderPanel(body){
    return this.http.post(`${environment.baseUrlAPI}/company/purchaseOrder/supplier/panel/dependency`, body , this.httpOptions);
  }

  requestPagination(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/invoice/request/pagination`, body , this.httpOptionsNew);
  }

  updateColumnsSupplierPurchaseOrderPanel(body){
    return this.http.post(`${environment.baseUrlAPI}/company/purchaseOrder/supplier/panel/updateColumns`, body , this.httpOptions);
  }

  paginationSupplierPurchaseOrderPanel(body){
    return this.http.post(`${environment.baseUrlAPI}/company/purchaseOrder/supplier/panel/pagination`, body , this.httpOptions);
  }

  graphicSupplierPurchaseOrderPanel(body){
    return this.http.post(`${environment.baseUrlAPI}/company/purchaseOrder/supplier/panel/graphic`, body , this.httpOptions);
  }

  //Detalle conformidades del proveedor
  detailPurchaseOrderByInvoice(body){
    return this.http.post(`${environment.baseUrlAPI}/company/purchaseOrder/supplier/conformities/detail`, body , this.httpOptions);
  }

  sendInvoice(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/invoice/create`, body , this.httpOptionsNew);
  }

  getBankNation(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/invoice/getBankNation`, body , this.httpOptionsNew);
  }

  multiplePurchaseOrderDependency(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/invoice/multiplePurchaseOrder/dependency`, body , this.httpOptionsNew);
  }

  multiplePurchaseOrderAvailable(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/invoice/multiplePurchaseOrder/available`, body , this.httpOptionsNew);
  }

  multiplePurchaseOrderConformities(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/invoice/multiplePurchaseOrder/conformities`, body , this.httpOptionsNew);
  }

  multiplePurchaseOrderCreate(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/invoice/multiplePurchaseOrder/create`, body , this.httpOptionsNew);
  }
}
